export default {
  pickup: 'Takeaway',
  delivery: 'Entrega',
  ongoing_order: 'Pedido em curso',
  view_more: 'Toque para ver detalhes',
  status: {
    rejected: {
      title: 'Pedido rejeitado',
      description: 'Toque para ver detalhes',
    },
    created: {
      description: 'Pedido recebido',
    },
    reviewed: {
      description: 'O seu pedido foi visto',
    },
  },
  order_type: {
    pickup: 'takeaway',
    delivery: 'entrega',
  },
  order_status_toast: {
    order_reviewed: '#{{number}} O seu pedido foi visto',
    order_confirmed: '#{{number}} Hora confirmada {{time}}',
    order_preparation_up_time_changed: '#{{number}} Hora de {{type}} alterada para {{time}}',
    order_preparing: 'O seu pedido #{{number}} está a ser preparado',
    order_rejected: 'Pedido #{{number}} rejeitado',
  },
  error_messages: {
    failed_to_load: 'Algo correu mal, por favor tente novamente.',
  },
};
